export * from './ich-detail.component';
export * from './ich-detail.component.module';